import { InputLabel, Stack, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import React from 'react'
import { DensityStyleTypes } from 'types'

interface ChildDateCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  label: string
}

const ChildDateCell: React.FC<ChildDateCellProps> = ({ params, densityStyles, label }) => {
  return (
    <Stack
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        width: '100%',
        height: '100%',
      }}
    >
      <InputLabel sx={{ textAlign: 'left', fontSize: densityStyles.labelSize }}>{label}</InputLabel>
      <Typography
        sx={{
          fontSize: densityStyles.fontSize,
        }}
      >
        {params.value}
      </Typography>
    </Stack>
  )
}

export default ChildDateCell
